/**
 *
 * @param {*} o
 * @returns {String}    ps: 'Number', 'String', 'Boolean', 'Function', 'Symbol', 'Array', 'Object', 'RegExp', 'Date', 'Null', 'Undefined', 'Map', 'Set', 'WeakMap', 'WeakSet', 'Window'
 */
function type(o) {
    return /\[object (\w+)\]/.exec(Object.prototype.toString.call(o))[1]
}

const obj = {}
const arr = ['Number', 'String', 'Boolean', 'Function', 'Symbol', 'Array', 'Object', 'RegExp', 'Date', 'Null', 'Undefined', 'Map', 'Set', 'WeakMap', 'WeakSet', 'Window']

/**
 * isNumber
 * isString
 * isBoolean
 * isFunction
 * isSymbol
 * isArray
 * isObject
 * isRegExp
 * isDate
 * isNull
 * isUndefined
 * isMap
 * isSet
 * isWeakMap
 * isWeakSet
 * isWindow
 */
arr.forEach(item => {
    obj['is' + item] = o => type(o) === item
})

export default obj

export const isNumber = obj.isNumber
export const isString = obj.isString
export const isBoolean = obj.isBoolean
export const isFunction = obj.isFunction
export const isSymbol = obj.isSymbol
export const isArray = obj.isArray
export const isObject = obj.isObject
export const isRegExp = obj.isRegExp
export const isDate = obj.isDate
export const isNull = obj.isNull
export const isUndefined = obj.isUndefined
export const isMap = obj.isMap
export const isSet = obj.isSet
export const isWeakMap = obj.isWeakMap
export const isWeakSet = obj.isWeakSet
export const isWindow = obj.isWindow
